const Special = () => {
  return (
    <div
      id="special"
      className="//greenbean relative w-full h-full px-[calc((100%-var(--container))/2)] pb-14 xl:pb-28 "
    >
      <div className=" relative w-full h-full mt-14 flex flex-wrap-reverse xl:grid xl:grid-cols-3 gap-5 xl:gap-10">
        <div className="relative w-full h-full grid grid-cols-2 grid-rows-2 gap-5">
          <div className="max-h-52 3xl:max-h-60">
            <img
              className="!relative w-full h-full object-cover object-center"
              src="images/bean1.png"
              alt="bean"
            />
          </div>
          <div className="max-h-52 3xl:max-h-60">
            <img
              className="!relative w-full h-full object-cover object-center"
              src="images/bean2.png"
              alt="bean"
            />
          </div>
          <div className="max-h-52 3xl:max-h-60">
            <img
              className="!relative w-full h-full object-cover object-center"
              src="images/bean3.png"
              alt="bean"
            />
          </div>
          <div className="max-h-52 3xl:max-h-60">
            <img
              className="!relative w-full h-full object-cover object-center"
              src="images/bean4.png"
              alt="bean"
            />
          </div>
        </div>
        <div className="xl:col-span-2 mt-10 xl:mt-0 relative w-full h-full">
          <div id="title" className="text-center lg:text-left">
            <h3>SPECIAL GREEN BEAN</h3>
          </div>
          <div className=" relative w-full h-full mt-7 leading-relaxed">
            <div
              data-aos="fade-up"
              className="p-5 rounded-md bg-black bg-opacity-80 text-white mb-3"
            >
              <h5>
                최상의 맛은 MASTER의 손길과 최고의 품질 생두에서 정해진다.
              </h5>
              <p className="mt-4">
                MASTER Sarah CHOI는 최고의 품질을 위하여, 매년 직접 산지로 가서
                농장의 프로세스 및 관리 시스템을 확 인하고,
                <br /> 그 해 수확된 생두의 품질을 확인 및 테스팅을 한 후에
                직수입 방식을 고수 합니다. 이와 같은 노력으로 항상 같은 원두의
                품질을 유지하고 있습니다.
              </p>
            </div>
            <div
              data-aos="fade-up"
              className="p-5 rounded-md bg-black bg-opacity-80 text-white"
            >
              <h5>
                농장주와의 깊은 유대관계에서 나오는 새로운 지식과 프로파일링
              </h5>
              <p className="mt-4">
                MASTER Sarah CHOI는 직수입 방식으로 통하여, 매년 농장주들과의
                만남을 갖고, 깊은 유대관계를 쌓고 있 습 니다.
                <br /> 깊은 관계성에서 비롯된 신뢰와 믿음을 통한 새롭고, 유명한
                스페셜 생두를 공급 받음으로써, 국내의 마스터 들 보다 스페셜
                생두에 대한 프로파일링을 갖고 있습니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Special;
